import NotificationsList
    from "../../components/notifications/NotificationsList"
export const NotificationsPage = () => {

    return (
        <NotificationsList></NotificationsList>
    )
}